// TODO(Sergio): Temporary skip eslint rules, this is part of the A6-A12 migration from mono-frontend

/* eslint-disable complexity, @typescript-eslint/no-explicit-any, @angular-eslint/no-host-metadata-property, @typescript-eslint/ban-types */
import { isPlatformBrowser } from '@angular/common';
import {
  Directive,
  ElementRef,
  Inject,
  Input,
  PLATFORM_ID,
  Renderer2
} from '@angular/core';
import { ScrollDirective } from './models/hide-footer-on-scroll.interfaces';

@Directive({
  selector: '[idpHideFooterOnScroll]',
  host: {
    '(scroll)': 'onContentScroll($event)'
  }
})
export class HideFooterOnScrollDirective {
  @Input() footer: ScrollDirective = {} as ScrollDirective;
  dialogContentMaxHeight = 0;
  footerHeight = 0;
  isFooterHidden = false;
  oldScroll = 0;
  nativeFooter: any;
  timeout: ReturnType<typeof setTimeout> = {} as ReturnType<typeof setTimeout>;

  constructor(
    public el: ElementRef,
    private renderer: Renderer2,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  onContentScroll(event: any) {
    clearTimeout(this.timeout);
    setTimeout(() => {
      if (
        isPlatformBrowser(this.platformId) &&
        (window.innerWidth <= 414 || window.innerHeight <= 414)
      ) {
        const scrollPos = event.srcElement.scrollTop;
        const max = event.srcElement.scrollHeight;
        const bottomPos = event.srcElement.offsetHeight + scrollPos;
        this.nativeFooter = this.footer.footerRef.nativeElement;
        this.isFooterHidden =
          this.nativeFooter.classList.contains('slide-down');
        const isFooterCtaVisible =
          this.nativeFooter.classList.contains('slide-up-half');
        if (this.isFooterHidden) {
          // If footer is hidden completely
          this.showFooterCTA();
        } else if (
          // If footer is visible completely and scroll down
          !this.isFooterHidden &&
          !isFooterCtaVisible &&
          this.isScrollDown(scrollPos)
        ) {
          this.showFooterCTA();
          this.changeDialogContentHeight('expand');
        }

        if (max === bottomPos && isFooterCtaVisible) {
          // Scroll all the way up and reach bottom and footer cta visible
          this.showFooter();
          this.changeDialogContentHeight('collapse');
        }
      }
    }, 1000);
  }

  showFooterCTA() {
    this.renderer.removeClass(this.nativeFooter, 'slide-down');
    this.renderer.addClass(this.nativeFooter, 'slide-up-half');
  }

  showFooter() {
    this.renderer.removeClass(this.nativeFooter, 'slide-down');
    this.renderer.removeClass(this.nativeFooter, 'slide-up-half');
  }

  isScrollDown(scrollPos: any) {
    const scrollDown = this.oldScroll > scrollPos;
    this.oldScroll = scrollPos;
    return scrollDown;
  }

  changeDialogContentHeight(type: any) {
    this.footerHeight = Number(
      window.getComputedStyle(this.nativeFooter).height.replace('px', '')
    );
    this.footerHeight =
      type === 'expand' ? -Math.abs(this.footerHeight) : this.footerHeight;
    const dialogContent = this.el.nativeElement;
    this.dialogContentMaxHeight = Number(
      window.getComputedStyle(dialogContent).maxHeight.replace('px', '')
    );
    this.renderer.setStyle(
      dialogContent,
      'max-height',
      'calc(' +
        Math.ceil(this.dialogContentMaxHeight - this.footerHeight) +
        'px)'
    );
  }
}
